import { render, staticRenderFns } from "./Propagandists.vue?vue&type=template&id=1c7ac3b0&"
import script from "./Propagandists.vue?vue&type=script&lang=js&"
export * from "./Propagandists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports